import { iframed } from "@utils/support";
import nluSessionId from "./nlu-session-id";
import { currentUser } from "./auth";
import createComponentConfigurationsStore from "./component-configurations";
import createFeaturesStore from "./features";
import { experience, introSeen, response, viewport } from "./global";

/**
 * Create and initialise stores
 *
 * @param {object} props
 * @param {object} props.experience
 * @param {Array<object>} props.features
 * @param {object} props.response
 * @param {boolean} props.introSeen
 */
export default function createStores(props = {}) {
  createComponentConfigurationsStore(props.experience.components);
  createFeaturesStore(props.features);
  currentUser.set(props.currentUser);
  nluSessionId.set(props.nluSessionId);
  experience.set(props.experience);
  introSeen.set(props.introSeen);
  response.set(props.response);

  if (iframed) {
    window.parent.postMessage("speakeasy:ready", "*");
    window.addEventListener("message", (event) => {
      if (event.data && event.data.type === "speakeasy:parent:resize") {
        viewport.update(() => ({
          // eslint-disable-next-line radix
          height: parseInt(event.data.height, 10),
          // eslint-disable-next-line radix
          width: parseInt(event.data.width, 10)
        }));
      }
    });
  }
}
